import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Container,
  Paper,
  CircularProgress,
  Alert,
  Button
} from '@mui/material';
import {
  Settings as SettingsIcon,
  ArrowForward as ArrowIcon
} from '@mui/icons-material';

/**
 * ⚠️ هذه الصفحة قديمة - تم دمج جميع الإعدادات في صفحة واحدة موحدة
 *
 * الصفحة الموحدة الجديدة: /admin/advanced-settings
 *
 * يتم إعادة التوجيه تلقائياً...
 */

const UnifiedImageSettingsPage: React.FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // إعادة توجيه فورية إلى الصفحة الموحدة
    navigate('/admin/advanced-settings', { replace: true });
  }, [navigate]);

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Paper sx={{ p: 4, textAlign: 'center' }}>
        <Box sx={{ mb: 3 }}>
          <CircularProgress size={60} />
        </Box>

        <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 1 }}>
          <SettingsIcon />
          جاري إعادة التوجيه...
        </Typography>

        <Alert severity="info" sx={{ mt: 3, mb: 2 }}>
          تم دمج جميع الإعدادات في صفحة واحدة موحدة لسهولة الإدارة.
        </Alert>

        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          سيتم نقلك تلقائياً إلى صفحة الإعدادات المتقدمة الموحدة.
        </Typography>

        <Button
          variant="contained"
          size="large"
          endIcon={<ArrowIcon />}
          onClick={() => navigate('/admin/advanced-settings', { replace: true })}
        >
          انتقل الآن إلى الصفحة الموحدة
        </Button>
      </Paper>
    </Container>
  );
};

export default UnifiedImageSettingsPage;
